export const basketItemKey = "basketState";
export const basketExpirationItemKey = "basketExpiration";
export const expirationDateFormat = "MM/DD/YYYY HH:mm:ss";
